import styles from './level.module.scss';
import RightsWrapper from './../../../rights-wrapper/rights-wrapper';
import { useState } from 'react';
import { ValueFormatterParams } from 'ag-grid-community';
import { useCourseGetRequestHook } from 'libs/webkua-lib/src/lib/requestUtils';
import { CreateHeaders, ErrorButton, HeaderSizeEnum, Icon, PrimaryButton, textHeader } from '@frontend-workspace/react-shared-lib';
import { ILevel } from './../../../_models/level';
import CreateNewLevelDialog from './create-new-level-dialog/create-new-level-dialog';
import DeleteLevelDialog from './delete-level-dialog/delete-level-dialog';
import WebkuaTable from '../../../webkua-table/webkua-table';
import LevelSkeleton from './level-skeleton';
import { useTranslation } from 'react-i18next';

/* eslint-disable-next-line */
export interface LevelProps { }

export function Level(props: LevelProps) {
  const { t } = useTranslation();
  const { data: levels, isLoading, getData: getLevels }: { data: ILevel[], isLoading: boolean, getData: () => void } = useCourseGetRequestHook(`resource/levels`, []);

  const [isNewLevelOpen, setIsNewLevelOpen] = useState(false);
  const [deleteLevel, setDeleteLevel] = useState<ILevel | undefined>(undefined);

  const toggleNewLevelOpen = () => setIsNewLevelOpen(!isNewLevelOpen);

  const openDeleteLevelDialog = (e: any) => setDeleteLevel(e.data);
  const closeDeleteLevelDialog = () => setDeleteLevel(undefined);

  const deleteRenderer = (params: ValueFormatterParams) => {
    return (
      <ErrorButton
        variant="outlined"
        size='small'
        onClick={() => openDeleteLevelDialog(params)}>
        {t('standard.delete')}
      </ErrorButton>
    );
  };

  return (<>
    <RightsWrapper>
      <div className='mb-3'>
        <PrimaryButton
          variant="contained"
          onClick={toggleNewLevelOpen}>
          <Icon className="me-1" fontSize="small">add</Icon>{t('standard.newLevel')}
        </PrimaryButton>
      </div>
    </RightsWrapper>
    {isLoading ? <LevelSkeleton /> :
      <WebkuaTable
        data={levels}
        headers={CreateHeaders([
          textHeader("name", t('standard.name'), HeaderSizeEnum.EXTRA_LARGE),
          textHeader("", "", HeaderSizeEnum.MEDIUM, {
            renderer: deleteRenderer,
            cellStyle: { justifyContent: 'right' },
            headerClass: "ag-right-aligned-header"
          })
        ])}
      />}
    {isNewLevelOpen && <CreateNewLevelDialog
      onClose={toggleNewLevelOpen}
      open={!!isNewLevelOpen}
      refreshData={getLevels}
    />}
    {deleteLevel && <DeleteLevelDialog
      onClose={closeDeleteLevelDialog}
      open={!!deleteLevel}
      refreshData={getLevels}
      levelId={deleteLevel.id}
    />}
  </>);
}

export default Level;
